import { Component, ChangeDetectionStrategy, inject, signal } from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from "@angular/router";
import {filter, Subscription} from "rxjs";
import {SidebarComponent} from './components/sidebar/sidebar.component';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, SidebarComponent],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
  private router = inject(Router);

  title = 'store';
  showNavigation = signal<boolean>(false);
  sub!: Subscription

  /**
   * Sign-in is the app's root path (`''`), so the nav must hide there — there is
   * nothing to navigate to before a token exists. It used to only ever turn ON,
   * which left the sidebar on screen after a sign-out returned to root; now it
   * tracks the route in both directions.
   */
  private static readonly NAV_FREE_ROUTES = ['', '/', '/login', '/register']

  constructor() {
    this.sub = this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe(e => {
      const val = e as NavigationEnd
      const url = (val.urlAfterRedirects || val.url).split('?')[0]
      this.showNavigation.set(!AppComponent.NAV_FREE_ROUTES.includes(url))
    })
  }
}
